import React, { Component } from 'react';
import { Row, Col, Input, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { SvgAssets } from '../../../assets/icons/iconSvg';
import GaugeChart from 'react-gauge-chart';
import { data } from '../../../constants/Constants';
import color from '../../../constants/Colors';
import TooltipLeyenda from '../../reusable/TooltipLeyenda';
import ValorCriterio from '../../reusable/ValorCriterio';

export class RepresentanteVenta extends Component {
  constructor(props) {
    super(props);
    this.state = {
          
    };
  }

	render() {
		const { } = this.state;

		return (
			<div style={{ flex: 1 }}>
				<div className="title_banner">
					<Container>
						<h1>Representante de ventas</h1>
					</Container>
					<SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
					</div>
					<div className="breadcrumb">
					<Container>
						<ul>
							<li><Link to='/vehiculo-dashboard'>Inicio</Link></li>
							<li>Representante de ventas</li>
						</ul>
					</Container>
				</div>
				<Container className="py-5">
					<div className="card_desktop">
						<div className="cards-wrap">
							<div className="card r_ventas">
								<div className="card-header">
									<h6>Mónica Diaz Morales</h6>
									<span>Vehículo 2R - Sur</span>
								</div>
								<div className="card-body">
									<div className="boxBorder">
										<span>Whatsapp</span>
										<button className='btn-small'>ESCRÍBENOS</button>
									</div>
									<p>Si prefieres darle una llamadita...</p>
									<div className="boxBorder">
										<span className="text-left">N° de celular<br/><div className="azul">987654321</div></span>
										<button className='btn-small bg_transparent'><SvgAssets icon="icon-phone-3" fill={color.verdeClaro} />LLAMA</button>
									</div>
									<div className="boxBorder d-flex justify-content-between">
										<a href="#"><SvgAssets icon="icon-mail" fill={color.azulClaro} />monica.diaz@crosland.com.pe</a>
									</div>
								</div>
							</div>
							<div className="card r_ventas">
								<div className="card-header">
									<h6>Mónica Diaz Morales</h6>
									<span>Vehículo 2R - Sur</span>
								</div>
								<div className="card-body">
									<div className="boxBorder">
										<span>Whatsapp</span>
										<button className='btn-small'>ESCRÍBENOS</button>
									</div>
									<p>Si prefieres darle una llamadita...</p>
									<div className="boxBorder">
										<span className="text-left">N° de celular<br/><div className="azul">987654321</div></span>
										<button className='btn-small bg_transparent'><SvgAssets icon="icon-phone-3" fill={color.verdeClaro} />LLAMA</button>
									</div>
									<div className="boxBorder d-flex justify-content-between">
										<a href="#"><SvgAssets icon="icon-mail" fill={color.azulClaro} />monica.diaz@crosland.com.pe</a>
									</div>
								</div>
							</div>
							<div className="card r_ventas">
								<div className="card-header">
									<h6>Mónica Diaz Morales</h6>
									<span>Vehículo 2R - Sur</span>
								</div>
								<div className="card-body">
									<div className="boxBorder">
										<span>Whatsapp</span>
										<button className='btn-small'>ESCRÍBENOS</button>
									</div>
									<p>Si prefieres darle una llamadita...</p>
									<div className="boxBorder">
										<span className="text-left">N° de celular<br/><div className="azul">987654321</div></span>
										<button className='btn-small bg_transparent'><SvgAssets icon="icon-phone-3" fill={color.verdeClaro} />LLAMA</button>
									</div>
									<div className="boxBorder d-flex justify-content-between">
										<a href="#"><SvgAssets icon="icon-mail" fill={color.azulClaro} />monica.diaz@crosland.com.pe</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Container>
			</div>
		)
	}
}